import React, { useRef } from 'react'
import { useScaleToFit } from '@hooks'
import { cn } from '@amusnet/react-ui'

interface UPModalButtonProps {
    id: string
    text: string
    isPrimary?: boolean
    onClick: () => void
}

const UPModalButton: React.FC<UPModalButtonProps> = ({ id, text, isPrimary = true, onClick }: UPModalButtonProps) => {
    const mainButtonsStyles = `text-[30px] text-white border-none rounded cursor-pointer font-bold transition-colors duration-300 w-[548px] h-[88px] flex items-center justify-center leading-[1.2]`
    const primaryBtnBackground = `bg-[url('/src/assets/ultra-play/button-primary-enabled.svg')] bg-cover bg-no-repeat bg-center`
    const secondaryBtnBackground = `bg-[url('/src/assets/ultra-play/button-secondary-enabled.svg')] bg-cover bg-no-repeat bg-center`
    const buttonComponentRef = useRef<HTMLButtonElement | null>(null)
    const buttonContentRef = useRef<HTMLSpanElement | null>(null)
    const scale = useScaleToFit(buttonComponentRef, buttonContentRef, [text], 0.9)

    return (
        <button
            ref={buttonComponentRef}
            id={id}
            className={cn(mainButtonsStyles, isPrimary ? primaryBtnBackground : secondaryBtnBackground)}
            onClick={onClick}
        >
            <span
                ref={buttonContentRef}
                style={{
                    zoom: scale,
                }}
                className="whitespace-nowrap"
            >
                {text}
            </span>
        </button>
    )
}

export default UPModalButton
